import { Box, Typography, MenuItem, Select, Divider } from "@mui/material";
import { ScopeType } from "./hooks/useEntityScopes";

export interface ScopeTableHeaderProps {
  scopeType: ScopeType;
  totalCount: number;
  onScopeTypeChange?: (scopeType: ScopeType) => void;
}

export function ScopeTableHeader({
  scopeType,
  totalCount,
  onScopeTypeChange,
}: ScopeTableHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography
        variant="h5"
        component="h2"
        sx={{
          fontWeight: 700,
          mr: 1,
          fontSize: "24px",
          lineHeight: "28px",
          color: "text.primary",
          letterSpacing: "-0.01em",
          whiteSpace: "nowrap",
        }}
      >
        {scopeType}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontSize: "24px",
          fontWeight: 700,
        }}
      >
        {totalCount}
      </Typography>
      <Divider
        flexItem={true}
        orientation="horizontal"
        sx={{ mx: 2, width: "100%", flexShrink: 1, height: 18 }}
      />
      {onScopeTypeChange && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontSize: "14px",
              fontWeight: 400,
              whiteSpace: "nowrap",
            }}
          >
            List View
          </Typography>
          <Select
            value={scopeType}
            onChange={(e) => onScopeTypeChange(e.target.value as ScopeType)}
            size="small"
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              minWidth: 140,
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
          >
            <MenuItem value="Organizations">Organizations</MenuItem>
            <MenuItem value="Spaces">Spaces</MenuItem>
            <MenuItem value="Workspaces">Workspaces</MenuItem>
          </Select>
        </Box>
      )}
    </Box>
  );
}
